import { render } from "./ProfilePassword.vue?vue&type=template&id=1efa5c92"
import script from "./ProfilePassword.vue?vue&type=script&lang=js"
export * from "./ProfilePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__